import { render, staticRenderFns } from "./Footnote.vue?vue&type=template&id=9a57db20&scoped=true&lang=pug"
var script = {}
import style0 from "./Footnote.vue?vue&type=style&index=0&id=9a57db20&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a57db20",
  null
  
)

export default component.exports